<template>
    <div>
        <div class="navbutton">
            <span class="onebutton" :class="{cur:curName==='政府信息公开申请'}"
                      @click="route_goFun('政府信息公开申请')">政府信息公开申请</span>
            <span class="twobutton" :class="{cur:curName==='申请查询'}" @click="route_goFun8('申请查询')">申请查询</span>
            <span class="threebutton" :class="{cur:curName==='热点信息'}" @click="route_goFun9('热点信息')">热点信息</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sideNavigation.vue",
        data() {
            return {
                curName: '政府信息公开申请',
                curId: '0',
            }
        },
        watch: {
            $route() {
                this.setCurName()
            },
        },
        created(){
            this.setCurName()
        },

        methods: {
            setCurName(){
                this.curName = this.$route.query.name || '政府信息公开申请'
                this.curId = this.$route.query.id || '0'
                window.SITE_CONFIG.curName = this.curName
                window.SITE_CONFIG.curId = this.curId
            },
            route_goFun(name) {
                this.$router.push({
                    path: '/',
                    query: {
                        name: name,
                        id: 0
                    }
                })
            },

            route_goFun9(name) {
                this.$router.push({
                    path: '/zwgk-door',
                    query: {
                        name: name,
                        id: 9
                    }
                })
            },
            route_goFun8(name) {
                this.$router.push({
                    path: '/select-result',
                    query: {
                        name: name,
                        id: 8
                    }
                })
            }
        }
    };

</script>

<style scoped lang="scss">
    .navbutton {
        /*position: fixed;*/
        /*left: 30px;*/
        margin: 20px auto;
        width: 160px;
        height: 200px;
        /*top: 200px;*/
        /*text-align: center;*/
    }

    .navbutton span {
        display: block;
        padding: 12px 8px;
        background-color: #008CFF;
        color: #ffffff;
        cursor: pointer;

        &.cur {
            background-color: #EDF5FF;
            color: #008cff;
            border-right: 4px solid #008cff;
            font-weight: 600;
        }
    }

    .navbutton .onebutton {
        border-bottom: 3px solid #cde1f7;
    }

    .navbutton .twobutton {
        border-bottom: 3px solid #cde1f7;
    }

    .navbutton .threebutton {
        border-bottom: 3px solid #cde1f7;
    }
</style>